import ModulesView, { ModuleCard }  from './ModulesView';

export { ModuleCard }

export default ModulesView